﻿"use strict";

import { ioDatatypes } from "../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter } from "../blib.js";

import * as blib from "../../../blib/index.js";
import * as xlib from "../../../xlib/index.js";

//import xlib = refs.xlib;



import * as pjscGlobalConfig from "../../../pjsc-config/client-config.js"; export { pjscGlobalConfig };


//import __ = xlib.lolo;



export var STRIPE_PUBLIC_KEY: string = null; //need to set production key
if ( __.isProd === true ) {
	STRIPE_PUBLIC_KEY = "pk_live_9kuAEhqiVfnSC1TaSv4WYjVY";
} else {
	STRIPE_PUBLIC_KEY = "pk_test_tLUHASpdsP50jOm9RtFverxC";
}

///**
// * if true, force the client to redirect to https
// */
//if (forceHttps === true) {
//	if (window.location.protocol != "https:" ) {		
//		window.location.href = "https:" + window.location.href.substring(window.location.protocol.length);
//	}
//}